import { Component, OnInit, Input } from '@angular/core';
import { UserApiService } from 'src/app/user-api.service';
import { UserApi, BilanEco } from 'src/app/models/api_models/user';

@Component({
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.scss']
})
export class UserInfoComponent implements OnInit {

  private _bilan : BilanEco = null;

  private _user : UserApi = null;
  get user()  : UserApi {
    return this._user;
  }
  @Input()
  set user(user : UserApi) {
    this._user = user;
    if (this._user != null) {
      let date = new Date();
      date.setDate(1);
      const start = new Date(date);
      date.setMonth(date.getMonth());
      date.setTime(date.getTime() - 1000 * 60 * 60 * 24);      
      this.userService.getUserBilanEco(this._user.id, start, date).subscribe(
        response => {
          this._bilan = response;
        }
      )
    }
  }

  constructor(private userService : UserApiService) { }

  ngOnInit() {
  }

}
